export default "<router-outlet>\r\n</router-outlet>"